module.exports = __webpack_public_path__ + "img/home_concept.65f59de6.jpg";